import { PageLoaderFunction, InjectAsyncReducer } from 'ha/types/routing';
import { loadHermesData } from 'ha/modules/Hermes';
import { getFavoriteListings } from 'ha/modules/FavoriteListing';
import {
  CollectionStats,
  collectionToFilters,
} from 'ha/utils/filters/collectionToFilters';
import { reportError } from 'ha/helpers/bugsnag/reportError';
import { searchParamsToObject } from 'ha/utils/routes/searchParamsToObject';
import { getFeatureFlags } from 'ha/modules/FeatureFlags';

import { STATE_NAME } from './constants';
import { reducer } from './reducer';
import { load, getCollectionStats, loadAdvertiser } from './actions';
import { validateUrl } from './utils/validateUrl';

export { SearchRootContainer as default } from './containers/SearchRoot';

export const loader: PageLoaderFunction = async args => {
  await validateUrl(args);

  const {
    params,
    request,
    context: { store },
  } = args;

  const { tenantMULFlow } = getFeatureFlags(store.getState());
  const isTenantMULFlowEnabled = tenantMULFlow === 'on';

  const localizedKind = params.localizedKind
    ? encodeURIComponent(params.localizedKind)
    : undefined;

  const url = new URL(request.url);
  const userId = url.searchParams.get('userId');
  const query = searchParamsToObject(url.searchParams);

  return store
    .dispatch(getCollectionStats(localizedKind, params.location))
    .then((stats: CollectionStats) =>
      Promise.all([
        store.dispatch(
          load({
            ...collectionToFilters(localizedKind, stats),
            ...params,
            ...query,
            localizedKind,
            priceAverage: stats.averagePrice,
          }),
        ),
        store.dispatch(loadHermesData(url.pathname)),
        store.dispatch(getFavoriteListings(isTenantMULFlowEnabled)),
        userId ? store.dispatch(loadAdvertiser(userId)) : Promise.resolve(),
      ]).catch(error => {
        reportError('Search Page Load Error', {
          metaData: { error, params, pathname: url.pathname, query, stats },
        });
      }),
    );
};

export const injectAsyncReducer: InjectAsyncReducer = store => {
  store.injectAsyncReducer(STATE_NAME, reducer);
};
